import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Login from "../pages/Auth/Login";
import Settings from "../pages/Settings";
import Profile from "../pages/Profile";
import Patients from "../pages/Patients";
import UserManagement from "../pages/Settings/UserManagement";
import SettingZone from "../pages/Settings/SettingZone";
import RecortExpend from "../pages/Settings/RecortExpend";
import RecordIncome from "../pages/Settings/RecordIncome";
import Wards from "../pages/Settings/Wards";
import Beds from "../pages/Settings/Beds";
import Barcode from "../pages/Settings/Barcode";
import Print from "../pages/Settings/Print";
import TaxRates from "../pages/Settings/TaxRates";
import Warehouse from "../pages/Settings/Warehouse";
import Modules from "../pages/Settings/Modules";
import CompanySettings from "../pages/Settings/CompanySettings";
import Accounting from "../pages/Settings/Accounting";
import PaymentsMode from "../pages/Settings/PaymentsMode";
import NewPatient from "../pages/Patients/NewPatient";
import Doctors from "../pages/Settings/Doctors";
import Ipd from "../pages/Ipd";
import PatientDetail from "../pages/Patients/AllPatients/PatientDetail";
import PatientHistory from "../pages/Patients/AllPatients/PatientHistory";
import HistoryDetails from "../pages/Patients/AllPatients/PatientHistory/HistoryDetails";
import Categories from "../pages/Settings/Categories";
import DoctorPanel from "../pages/Doctor/DoctorPanel";
import Appointments from "../pages/Doctor/DoctorPanel/Appointments";
import SeeVitals from "../pages/Doctor/DoctorPanel/NewPatients/seeVitals";
import ItemRecord from "../pages/Warehouse/ItemRecord";
import RecordSuppliers from "../pages/Warehouse/RecordSuppliers";
import MainPatientVitals from "../pages/Patients/AllPatients/MainPatientVitals";
import Samples from "../pages/Settings/LabSetting/Samples";
import Remarks from "../pages/Settings/LabSetting/Remarks";
import LabRecord from "../pages/Lab/LabRecord";
import SuppiersOrder from "../pages/Warehouse/SuppiersOrder";
import NewSupplerOrder from "../pages/Warehouse/SuppiersOrder/NewSuppliersOrder";
import StockReports from "../pages/Warehouse/StockReports";
import ProductDiscount from "../pages/Settings/ProductDiscount";
import NewTransfertOrder from "../pages/Warehouse/TransfertOrder/NewTransfertOrder";
import TransfertOrder from "../pages/Warehouse/TransfertOrder";
import PhTransfertOrder from "../pages/Pharmacy/PhTransfertOrder";
import PhNewTransfertOrder from "../pages/Pharmacy/PhTransfertOrder/PhNewTransfertOrder";
import PhStockReports from "../pages/Pharmacy/PhStockReports";
import AllSales from "../pages/Cashier/AllSales";
import LabRecordDetail from "../pages/Lab/LabRecordDetail";
import FinancialYear from "../pages/Settings/FinancialYear";
import PhInvoiceList from "../pages/Pharmacy/PhInvoiceList";
import PhOccupiedWards from "../pages/Pharmacy/PhOccupiedWards";
import PhInvoiceDetails from "../pages/Pharmacy/PhOccupiedWards/PhInvoiceDetails";
import PatientAccountDetail from "../pages/Cashier/AllSales/PatientAccount/PatientAccountDetail";
import Banking from "../pages/Accountant/Banking";
import Requisitions from "../pages/Accountant/Requisitions";
import CreateRequisition from "../pages/Accountant/Requisitions/CreateRequisition";
import CashRequisition from "../pages/Cashier/CashRequisition";
import Cashdrop from "../pages/Cashier/Cashdrop";
import OtherRevenue from "../pages/Cashier/OtherRevenue";
import CashCreateRequisition from "../pages/Cashier/CashRequisition/CashCreateRequisition";
import CashDesk from "../pages/Settings/CashDesk";
import SeeLabDoctor from "../pages/Doctor/DoctorPanel/PatientFromLab/SeeLabDoctor";
import CashJournal from "../pages/Cashier/CashJournal";
import BillDischarge from "../pages/Patients/AllPatients/BillDischarge";
import Budgeting from "../pages/Accountant/Budgeting";
import Trial from "../pages/Accountant/Trial";
import PatientsCheckout from "../pages/Cashier/PatientsCheckout";
import Guarantors from "../pages/Settings/Guarantors";
import AccountSummary from "../pages/Cashier/AccountSummary";
import SummaryDetails from "../pages/Cashier/AccountSummary/SummaryDetails";
import PhStockTransfert from "../pages/Pharmacy/PhStockTransfert";
import PhNewStockTransfert from "../pages/Pharmacy/PhStockTransfert/PhNewStockTransfert";
import PhInventory from "../pages/Pharmacy/PhInventory";
import PhNewInventory from "../pages/Pharmacy/PhInventory/PhNewInventory"
import Inventory from "../pages/Warehouse/Inventory";
import NewInventory from "../pages/Warehouse/Inventory/NewInventory";
import PatientAccountSummary from "../pages/Patients/PatientAccountSummary";
import IncomesR from "../pages/Accountant/IncomesR";
import BankAccHistory from "../pages/Accountant/Banking/BankAccHistory";
import CashDeskJournal from "../pages/Cashier/CashDeskJournal";
import PayrollSettings from "../pages/Payroll/Settings";
import StaffType from "../pages/Payroll/Settings/StaffType";
import CreateStaffType from "../pages/Payroll/Settings/StaffType/createStaffType";
import Departments from "../pages/Payroll/Settings/Departments";
import CreateDepartment from "../pages/Payroll/Settings/Departments/createDepartment";
import CreatePosition from "../pages/Payroll/Settings/Positions/createPosition";
import Positions from "../pages/Payroll/Settings/Positions";
import CreateEchelon from "../pages/Payroll/Settings/Echelons/createEchelon";
import Echelons from "../pages/Payroll/Settings/Echelons";
import PCategories from "../pages/Payroll/Settings/PCategories";
import CreateCategory from "../pages/Payroll/Settings/PCategories/createCategory";
import Bonus from "../pages/Payroll/Settings/Bonus";
import CreateBonus from "../pages/Payroll/Settings/Bonus/createBonus";
import { Journal } from "../pages/Accountant/journal";
import StaffManagement from "../pages/Payroll/Settings/StaffManagement";
import CreateEmployee from "../pages/Payroll/Settings/StaffManagement/createEmployee";
import UpdateEmployee from "../pages/Payroll/Settings/StaffManagement/updateEmployee";
import DeductionCategories from "../pages/Payroll/DeductionMaster/DeductionCategories";
import DeductionMaster from "../pages/Payroll/DeductionMaster";
import AddDeductionCategory from "../pages/Payroll/DeductionMaster/DeductionCategories/AddDeductionCategory";
import EditDeductionCategory from "../pages/Payroll/DeductionMaster/DeductionCategories/EditDeductionCategory";
import AssignLoans from "../pages/Payroll/Loans/assignLoans";
import AssignAdvancedSalary from "../pages/Payroll/Loans/assignAdvancedSalary";
import PayrollManagement from "../pages/Payroll/Loans/"
import LoansHistory from "../pages/Payroll/Loans/LoansHistory";
import AdvancedSalaryHistory from "../pages/Payroll/Loans/AdvancedSalaryHistory";
import Deductions from "../pages/Payroll/DeductionMaster/Deductions/Deductions";
import AddDeduction from "../pages/Payroll/DeductionMaster/Deductions/AddDeduction";
import EditDeduction from "../pages/Payroll/DeductionMaster/Deductions/EditDeduction";
import DeductionSettingsList from "../pages/Payroll/DeductionMaster/DeductionSettings/DeductionSettingsList";
import AssignDeductions from "../pages/Payroll/DeductionMaster/Deductions/AssignDeductions";
import AssignBonus from "../pages/Payroll/Settings/Bonus/AssignBonus";
import RecordBackup from "../pages/Backup/RecordBackup";
import ListBackup from "../pages/Backup/ListBackup";
import StockTransactionDetails from "../pages/Warehouse/StockReports/StockTransactionDetails";
import MySales from "../pages/Reports/My sale";
import MyWards from "../pages/Reports/My Ward";
import SalesReportDetails from "../pages/Reports/My sale/details";
import WardReportDetails from "../pages/Reports/My Ward/details";
import PayMaster from "../pages/Payroll/PayMaster";
import PaySlipDetails from "../pages/Payroll/PayMaster/paySlipDetails";
import CNPSReports from "../pages/Payroll/Reports/CNPS-reports";
import TaxReports from "../pages/Payroll/Reports/Tax-reports";
import BonusSettings from "../pages/Payroll/Settings/Bonus/BonusSettings";
import LetterHead from "../pages/Payroll/Settings/LetterHead";
import Allowance from "../pages/Payroll/Settings/Allowances/indexs";
import CreateAllowance from "../pages/Payroll/Settings/Allowances/CreateAllowance";
import AllowanceSettings from "../pages/Payroll/Settings/Allowances/AllowanceSettings";




const authProtectedRoutes = [
    { path: "/dashboard", component: <Dashboard /> },
    { path: "/profile", component: <Profile /> },
    { path: "/settings", component: <Settings /> },
    { path: "/patients/:param?", component: <Patients /> },
    { path: "/admit-patient", component: <Ipd /> },
    { path: "/patients/details/:id/:param", component: <PatientDetail /> },
    { path: "/patients/history/:id", component: <PatientHistory /> },
    { path: "/patients/history/:id", component: <PatientHistory /> },
    { path: "/patients/history_details/:id", component: <HistoryDetails /> },
    { path: "/patients/bill_discharge/history_details/", component: <BillDischarge /> },
    { path: "/patients/create/:id?/:param?/:action?", component: <NewPatient /> },
    { path: "/patients/history/vitals/:id/:record?", component: <MainPatientVitals /> },
    { path: "/patients/account-summary/:id", component: <PatientAccountSummary /> },
    { path: "/settings/user_management", component: <UserManagement /> },
    { path: "/settings/setting_zone", component: <SettingZone /> },
    { path: "/settings/record_expenditure", component: <RecortExpend /> },
    { path: "/settings/record_income", component: <RecordIncome /> },
    { path: "/settings/payments_mode", component: <PaymentsMode /> },
    { path: "/settings/wards", component: <Wards /> },
    { path: "/settings/beds", component: <Beds /> },
    { path: "/settings/productsDiscount", component: <ProductDiscount /> },
    { path: "/settings/barcode", component: <Barcode /> },
    { path: "/settings/print", component: <Print /> },
    { path: "/settings/taxe_rates", component: <TaxRates /> },
    { path: "/settings/warehouse-branchs", component: <Warehouse /> },
    { path: "/settings/modules", component: <Modules /> },
    { path: "/settings/company_settings", component: <CompanySettings /> },
    { path: "/settings/accounting", component: <Accounting /> },
    { path: "/settings/doctors", component: <Doctors /> },
    { path: "/settings/guarantors", component: <Guarantors /> },
    { path: "/settings/categories", component: <Categories /> },
    { path: "/doctor/doctor-panel-see-patient", component: <DoctorPanel /> },
    { path: "doctor/doctor-panel/appointment", component: <Appointments /> },
    { path: "/doctor/doctor-panel/see-vitals/:id/:ref/:name", component: <SeeVitals /> },
    { path: "/doctor/doctor-panel/see-lab-record/:id/:ref/:name", component: <SeeLabDoctor /> },
    { path: "/warehouse/item-record", component: <ItemRecord /> },
    { path: "/warehouse/record-supplier", component: <RecordSuppliers /> },
    { path: "/warehouse/purchase-supplier", component: <SuppiersOrder /> },
    { path: "/warehouse/purchase-supplier-order/:id?/:action?", component: <NewSupplerOrder /> },
    { path: "/warehouse/transfert-order", component: <TransfertOrder /> },
    { path: "/warehouse/transfert-order-new/:id?/:action?", component: <NewTransfertOrder /> },
    { path: "/pharmacy/invoices-list/:section?", component: <PhInvoiceList /> },
    { path: "/pharmacy/occupied_wards/details/:id?/:patientId?/:wardNo?", component: <PhInvoiceDetails /> },
    { path: "/pharmacy/occupied_wards", component: <PhOccupiedWards /> },
    { path: "/pharmacy/transfert-order", component: <PhTransfertOrder /> },
    { path: "/pharmacy/transfert-order-new/:id?/:action?", component: <PhNewTransfertOrder /> },

    { path: "/pharmacy/stock-transfert", component: <PhStockTransfert /> },
    { path: "/pharmacy/stock-transfert-new/:id?/:action?", component: <PhNewStockTransfert /> },

    { path: "/pharmacy/inventory", component: <PhInventory /> },
    { path: "/pharmacy/inventory-new/:id?/:action?", component: <PhNewInventory /> },

    { path: "/warehouse/inventory", component: <Inventory /> },
    { path: "/warehouse/inventory-new/:id?/:action?", component: <NewInventory /> },

    { path: "/pharmacy/stock-reports", component: <PhStockReports /> },
    { path: "/warehouse/stock-reports", component: <StockReports /> },
    { path: "/settings/cash-desk", component: <CashDesk /> },
    { path: "/settings/samples", component: <Samples /> },
    { path: "/settings/remarks", component: <Remarks /> },
    { path: "/lab/lab-record", component: <LabRecord /> },
    { path: "/lab/lab-record/detail/:id?", component: <LabRecordDetail /> },
    { path: "/cashier/all-sales/:section?", component: <AllSales /> },
    { path: "/cashier/all-sales/patientAccount/:id?/:accountRef?/:balance?", component: <PatientAccountDetail /> },
    { path: "/settings/financial-year", component: <FinancialYear /> },
    { path: "/accounting/banking", component: <Banking /> },
    { path: "/accounting/banking/:id?", component: <BankAccHistory /> },
    { path: "accounting/budgeting", component: <Budgeting /> },
    { path: "/accounting/requisitions", component: <Requisitions /> },
    { path: "/accounting/requisitions/create/:action?/:id?", component: <CreateRequisition /> },
    { path: "/accounting/report-incomes", component: <IncomesR /> },
    { path: "/accounting/trial-balance", component: <Trial /> },
    { path: "/accounting/journal", component: <Journal /> },

    { path: "/cashier/requisitions", component: <CashRequisition /> },
    { path: "/cashier/requisitions/create/:action?/:id?", component: <CashCreateRequisition /> },
    { path: "/cashier/cashdrop", component: <Cashdrop /> },
    { path: "/cashier/cash-journal", component: <CashJournal /> },
    { path: "/cashier/other-revenue", component: <OtherRevenue /> },
    { path: "/cashier/patients-checkout", component: <PatientsCheckout /> },
    { path: "/cashier/account-summary", component: <AccountSummary /> },
    { path: "/cashier/account-summary/details/:id", component: <SummaryDetails /> },
    { path: "/cashier/cashdesk-journal", component: <CashDeskJournal /> },
    { path: "/payroll/setting", component: <PayrollSettings /> },
    { path: "/payroll/setting/letterhead", component: <LetterHead /> },
    { path: "/payroll/setting/staffType", component: <StaffType /> },
    { path: "/payroll/setting/staffType/create/:id?/:label?", component: <CreateStaffType /> },
    { path: "/payroll/setting/departments", component: <Departments /> },
    { path: "/payroll/setting/departments/create/:id?/:label?", component: <CreateDepartment /> },
    { path: "/payroll/setting/positions", component: <Positions /> },
    { path: "/payroll/setting/positions/create/:id?/:label?", component: <CreatePosition /> },
    { path: "/payroll/setting/echelons", component: <Echelons /> },
    { path: "/payroll/setting/echelons/create/:id?/:label?", component: <CreateEchelon /> },
    { path: "/payroll/setting/categories", component: <PCategories /> },
    { path: "/payroll/setting/categories/create/:id?/:label?", component: <CreateCategory /> },
    { path: "/payroll/staff-management", component: <StaffManagement /> },
    { path: "payroll/staff-management/create", component: <CreateEmployee /> },//create employee
    { path: "payroll/staff-management/update/:id?", component: <UpdateEmployee /> },// update employee

    { path: "/payroll/setting/allowances", component: <Allowance /> },
    { path: "/payroll/setting/allowances/:action/:id?/:allowanceName?/:rate?/:taxable?/:cnpsContribution?", component: <CreateAllowance /> },
    { path: "/payroll/setting/allowances/:id/settings", component: <AllowanceSettings /> },

// bonus
    { path: "/payroll/setting/bonus", component: <Bonus /> },
    { path: "/payroll/setting/bonus/:id/settings", component: <BonusSettings /> },
    { path: "/payroll/setting/bonus/create/:id?/:label?", component: <CreateBonus /> },

    // Deduction Categories & deductions links
    { path: "/payroll/deduction-master", component: <DeductionMaster /> },
    { path: "/payroll/deduction-categories", component: <DeductionCategories /> },
    { path: "/payroll/deduction-categories/add", component: <AddDeductionCategory /> },
    { path: "/payroll/deduction-categories/:id/edit", component: <EditDeductionCategory /> },

    //Payroll - Paymaster links
    { path: "/payroll/paymaster", component: <PayMaster /> },
    { path: "/payroll/paymaster/:id", component: <PaySlipDetails /> },



    // Deduction Categories & deductions links
    { path: "/payroll/deductions", component: <Deductions /> },
    { path: "/payroll/deductions/add", component: <AddDeduction /> },
    { path: "/payroll/deductions/:id/edit", component: <EditDeduction /> },
    { path: "/payroll/deductions/:id/settings", component: <DeductionSettingsList /> },
    { path: "/payroll/deductions/:id/assign", component: <AssignDeductions /> },
    { path: "/payroll/bonus/:id/assign", component: <AssignBonus /> },

    //Loans and Advanced Salary links
    { path: "/payroll/loans/:id/assign/:name", component: <AssignLoans /> },
    { path: "/payroll/advanced-salary/:id/assign/:name", component: <AssignAdvancedSalary /> },
    { path: "/payroll/loans", component: <PayrollManagement /> },
    { path: "/payroll/loans/:id/history", component: <LoansHistory /> },
    { path: "/payroll/advanced-salary/:id/history", component: <AdvancedSalaryHistory /> },

    //pharmacy reports details
    { path: "/reports/mySales", component: <MySales /> },
    { path: "/reports/mySales/:id", component: <SalesReportDetails /> },
    { path: "/reports/postedSales", component: <MyWards /> },
    { path: "/reports/postedSales/:id", component: <WardReportDetails /> },

    //Admin reports 
    { path: "/reports/cnps", component: <CNPSReports /> },
    { path: "/reports/tax", component: <TaxReports /> },

    //Stock reports details
    { path: "/stock-transaction/:id", component: <StockTransactionDetails /> },

    //Backup links
    { path: "/backup/record", component: <RecordBackup /> },
    { path: "/backup", component: <ListBackup /> },


    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    {
        path: "/",
        exact: true,
        component: <Navigate to="/dashboard" />,
    },
    { path: "*", component: <Navigate to="/dashboard" /> },
]

const publicRoutes = [
    { path: "/login", component: <Login /> },
]

export { authProtectedRoutes, publicRoutes };
